import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const NewsletterToolsPanel = () => {
  const [activeSubTab, setActiveSubTab] = useState('campaigns');

  const subTabs = [
    { id: 'campaigns', label: 'Campaigns', icon: 'Mail' },
    { id: 'templates', label: 'Templates', icon: 'FileText' },
    { id: 'subscribers', label: 'Subscribers', icon: 'Users' },
    { id: 'analytics', label: 'Analytics', icon: 'BarChart3' }
  ];

  const mockCampaigns = [
    { id: 1, name: 'Monthly Newsletter', status: 'sent', recipients: 1245, openRate: '24.5%', sentDate: '2024-01-15' },
    { id: 2, name: 'New Vendor Spotlight', status: 'draft', recipients: 0, openRate: '-', sentDate: '-' },
    { id: 3, name: 'Wedding Season Promo', status: 'scheduled', recipients: 2100, openRate: '-', sentDate: '2024-01-20' }
  ];

  const renderSubTabContent = () => {
    switch (activeSubTab) {
      case 'campaigns':
        return (
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-soft p-6">
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
                <h3 className="font-heading font-semibold text-lg text-text-primary">
                  Email Campaigns
                </h3>
                <Button variant="primary" iconName="Plus" iconSize={16}>
                  Create Campaign
                </Button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <Input placeholder="Search campaigns..." icon="Search" />
                <select className="px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500">
                  <option>All Status</option>
                  <option>Draft</option>
                  <option>Scheduled</option>
                  <option>Sent</option>
                </select>
                <select className="px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500">
                  <option>All Types</option>
                  <option>Newsletter</option>
                  <option>Promotional</option>
                  <option>Transactional</option>
                </select>
              </div>

              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-surface-100">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Campaign Name
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Status
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Recipients
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Open Rate
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Sent Date
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-border">
                    {mockCampaigns.map((campaign) => (
                      <tr key={campaign.id} className="hover:bg-surface-50">
                        <td className="px-4 py-3">
                          <div className="flex items-center">
                            <div className="w-8 h-8 bg-primary-100 rounded-lg flex items-center justify-center mr-3">
                              <Icon name="Mail" size={16} className="text-primary" />
                            </div>
                            <span className="font-medium text-text-primary">{campaign.name}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${
                            campaign.status === 'sent' ? 'bg-success-100 text-success' : 
                            campaign.status === 'scheduled'? 'bg-blue-100 text-blue-600' : 'bg-gray-100 text-gray-600'
                          }`}>
                            {campaign.status}
                          </span>
                        </td>
                        <td className="px-4 py-3 text-text-secondary">{campaign.recipients}</td>
                        <td className="px-4 py-3 text-text-secondary">{campaign.openRate}</td>
                        <td className="px-4 py-3 text-text-secondary">{campaign.sentDate}</td>
                        <td className="px-4 py-3">
                          <div className="flex items-center space-x-2">
                            <button className="text-primary hover:text-primary-600">
                              <Icon name="Edit" size={16} />
                            </button>
                            <button className="text-gray-500 hover:text-gray-700">
                              <Icon name="Copy" size={16} />
                            </button>
                            <button className="text-red-500 hover:text-red-700">
                              <Icon name="Trash2" size={16} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );
      case 'templates':
        return (
          <div className="bg-white rounded-xl shadow-soft p-6">
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="FileText" size={32} className="text-primary" />
              </div>
              <h3 className="font-heading font-semibold text-xl text-text-primary mb-2">
                Email Templates
              </h3>
              <p className="text-text-secondary mb-6">
                Create and manage email templates
              </p>
              <Button variant="outline" disabled>
                Manage Templates
              </Button>
            </div>
          </div>
        );
      case 'subscribers':
        return (
          <div className="bg-white rounded-xl shadow-soft p-6">
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Users" size={32} className="text-primary" />
              </div>
              <h3 className="font-heading font-semibold text-xl text-text-primary mb-2">
                Subscriber Management
              </h3>
              <p className="text-text-secondary mb-6">
                Manage newsletter subscribers and segments
              </p>
              <Button variant="outline" disabled>
                View Subscribers
              </Button>
            </div>
          </div>
        );
      case 'analytics':
        return (
          <div className="bg-white rounded-xl shadow-soft p-6">
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="BarChart3" size={32} className="text-primary" />
              </div>
              <h3 className="font-heading font-semibold text-xl text-text-primary mb-2">
                Email Analytics
              </h3>
              <p className="text-text-secondary mb-6">
                Track email performance and engagement
              </p>
              <Button variant="outline" disabled>
                View Analytics
              </Button>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-primary to-secondary rounded-xl p-6 text-white">
        <h2 className="font-heading font-bold text-2xl mb-2">
          Newsletter Tools
        </h2>
        <p className="text-white/90">
          Manage email campaigns and newsletters
        </p>
      </div>

      {/* Sub Navigation */}
      <div className="bg-white rounded-xl shadow-soft p-6">
        <div className="flex flex-wrap gap-2">
          {subTabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveSubTab(tab.id)}
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                activeSubTab === tab.id
                  ? 'bg-primary text-white' :'text-text-secondary hover:bg-surface-100'
              }`}
            >
              <Icon name={tab.icon} size={16} />
              <span className="font-medium">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Sub Tab Content */}
      {renderSubTabContent()}
    </div>
  );
};

export default NewsletterToolsPanel;